<template>
  <el-table-column :prop="prop" :min-width="(isExpanded || !collapseAble) ? expandedWidth : collapsedWidth"
    :class-name="isExpanded ? '' : 'collapsed-column'" v-bind="$props" :show-overflow-tooltip="showOverflowTooltip">
    <!-- 自定义表头（添加眼睛图标） -->
    <template slot="header" slot-scope="{ column }">
      <div class="header-wrapper" :style="headerAlign">
        <span class="header-label" v-if="isExpanded || !collapseAble">{{ label }}</span>
        <i class="el-icon-view eye-icon" :class="isExpanded ? '' : 'eye-close'" @click.stop="toggleCollapse"
          :title="label" v-if="collapseAble" />
      </div>
    </template>

    <!-- 列内容（收起时隐藏） -->
    <template slot-scope="scope">
      <div v-show="isExpanded || !collapseAble">
        <slot name="content" :row="scope.row">
          {{ scope.row[prop] }}
        </slot>
      </div>
    </template>
  </el-table-column>
</template>

<script>
export default {
  name: 'CollapseTableColumn',
  props: {
    prop: String,        // 列数据字段
    label: String,       // 表头标签
    collapseAble: {      // 是否可收起
      type: Boolean,
      default: true
    },
    expandedWidth: {     // 展开时的宽度
      type: [String, Number],
      default: '150px'
    },
    collapsedWidth: {    // 收起时的宽度（仅容纳图标）
      type: [String, Number],
      default: '40px'
    },
    defaultExpanded: {   // 默认展开状态
      type: Boolean,
      default: true
    },
    align: {             // 列对齐方式
      type: String,
      default: 'left'
    },
    showOverflowTooltip: { // 内容过长时是否显示tooltip
      type: Boolean,
      default: false
    },
    fixed: {             // 是否固定列
      type: String | Boolean,
      default: false
    },
    minWidth: {          // 最小列宽度
      type: [String, Number],
      default: ''
    },
  },
  data() {
    return {
      isExpanded: this.defaultExpanded
    };
  },
  computed: {
    headerAlign() {
      let value = ''
      if (this.align == 'left') {
        value = 'flex-start'
      } else if (this.align == 'center') {
        value = 'center'
      } else if (this.align == 'right') {
        value = 'flex-end'
      }
      return `justify-content: ${value};`
    }
  },
  methods: {
    toggleCollapse() {
      this.isExpanded = !this.isExpanded;
      // 触发表格重新布局（解决列宽变化时的渲染问题）
      this.$nextTick(() => {
        this.$parent.doLayout && this.$parent.doLayout();
      });
    }
  }
};
</script>

<style scoped lang="scss">
.header-wrapper {
  display: flex;
  align-items: center;
  gap: 5px;
  flex-wrap: wrap;
}

.header-label {
  // 不换行
  white-space: nowrap;
}

.eye-icon {
  cursor: pointer;
  font-size: 16px;
  color: #a7abb0;
  position: relative;
}

.eye-close::after {
  content: '';
  position: absolute;
  display: block;
  width: 1px;
  height: 120%;
  background-color: #a7abb0;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(45deg);
  transform-origin: center;
}

/* 收起时隐藏表头标签 */
/deep/ .collapsed-column .cell span:first-child {
  display: none;
}

/* 收起时隐藏内容区域 */
/deep/ .collapsed-column .el-table__cell {
  padding: 0;
}
</style>
